import { TypeHelper } from "@iconics/core";
import { ODataSelect } from "@iconics/core";

export class Package extends ODataSelect
{
    public Id = '';
    public Name = '';
    public DisplayName = '';
    public Description = '';
    public IsEnabled = false;
    public '@odata.etag' = '';

    public init(response: any, nodeId: number): ODataSelect
    {
        Object.assign(this, response);
        this.IsEnabled = TypeHelper.toBoolean(response.IsEnabled) ?? false;
        return this;
    }

    public toSelect(): string
    {
        return '';
    }
}

export class Entity extends ODataSelect
{
    public Id = 0;
    public Name = "";
    public Package_ID = "";
}

export class PublisherEntity extends ODataSelect
{
    public Id = 0;
    public EventTypeId = 0;
    public Name = "";
    public ForwardEvent = "";
    public '@odata.etag' = "";

    public toSelect(): string
    {
        return '';
    }
}